import * as s from './styles';
import type { IGatsbyImageData } from 'gatsby-plugin-image';
import Buttons from '@klv/molecules/buttons';
import type { IFullColumnImageCta } from './types';

const FullColumnImageCta = ({ gradientHeadline, image, buttons }: IFullColumnImageCta) => {
  return (
    <s.StyledGrid>
      <s.FadeInUpGrid>
      {gradientHeadline?.headline && (
        <s.Title
          colorVariant='light'
          forwardedAs= 'h2'
          variant='h2'
          dangerouslySetInnerHTML={{ __html: gradientHeadline.headline }}
        />
      )}
      </s.FadeInUpGrid>
      <s.FadeInUpGrid>
        {image && <s.FullColumnImageCtaImage altText={image?.altText}  imageData={image?.gatsbyImage as IGatsbyImageData}/>}
      </s.FadeInUpGrid> 
        <s.FadeInUpGrid>
        {buttons && ( 
          <s.IntegrationCtaWrapper>
            <Buttons
              buttonColor="light"
              variants={['ghost']}
              buttons={buttons}
            /> 
          </s.IntegrationCtaWrapper>
        )}
        </s.FadeInUpGrid>
    </s.StyledGrid>
  );
};

export default FullColumnImageCta;
